import Cookies from "js-cookie";
import { getCsrfToken } from "@/app/_utils/csrf";

class TemplateService {
  static instance: TemplateService;

  csrfToken = getCsrfToken();
  tenant = Cookies.get("tenant") ?? "";
  baseUrl = `${import.meta.env.VITE_API_BASE_URL}`;

  getTemplateAsync = async (id: string) => {
    const res = await fetch(`${this.baseUrl}templates/${id}/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  getTemplatesAsync = async (isSample?: boolean) => {
    const params = new URLSearchParams();
    if (isSample !== undefined) {
      params.set("is_sample", isSample ? "true" : "false");
    }
    const query = params.toString();
    const res = await fetch(
      `${this.baseUrl}templates/${query ? `?${query}` : ""}`,
      {
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      }
    );
    return await res.json();
  };

  getSampleTemplatesAsync = async () => {
    return this.getTemplatesAsync(true);
  };

  createTemplateAsync = async (template: any) => {
    const res = await fetch(`${this.baseUrl}templates/`, {
      method: "POST",
      body: JSON.stringify(template),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });

    const data = await res.json();
    if (!res.ok) {
      throw new Error(
        data?.detail ?? data?.message ?? "Failed to create template"
      );
    }
    return data;
  };

  sendTestEmail = async (email: string, template: any) => {
    return await fetch(`${this.baseUrl}templates/send-test/`, {
      method: "POST",
      body: JSON.stringify({ email, ...template }),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });
  };

  updateTemplateAsync = async (id: string, template: any) => {
    const res = await fetch(`${this.baseUrl}templates/${id}/`, {
      method: "PUT",
      body: JSON.stringify(template),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });

    const data = await res.json();
    if (!res.ok) {
      throw new Error(
        data?.detail ?? data?.message ?? "Failed to update template"
      );
    }
    return data;
  };

  deleteTemplateAsync = async (id: string) => {
    return await fetch(`${this.baseUrl}templates/${id}/`, {
      method: "DELETE",
      headers: { "X-CSRFToken": getCsrfToken() },
      credentials: "include",
    });
  };
}

export const templateService = new TemplateService();
